import { BatteryCharging, BellOff } from "lucide-react";

// Values shared by the phone-side SecondaryCamera page and the host-side
// QR/pairing flow (useSecondaryCamera hook, SecondaryCameraConnectStep).

// Tutorial clip on the host-side "Connect your phone" step. Hosted on the same
// public S3 bucket as the Help section videos (see config/helpVideos.js) rather
// than /public, so the ~49MB file stays out of the build and off the app server.
export const TUTORIAL_VIDEO_URL =
  "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/SecondaryCameraInstructions.mp4";

// Local UI phases for the phone-side page.
export const PHASES = {
  VALIDATING: "validating",
  INVALID: "invalid",
  SETUP: "setup", // instruction slides — camera not yet acquired
  POSITIONING: "positioning", // live self-view — camera acquired/attached
  ACTIVE: "active",
  ENDED: "ended",
  RESCAN: "rescan",
};

// Instruction slides shown before the live positioning slide, in this order.
export const SETUP_STEPS = [
  {
    id: "charge",
    icon: BatteryCharging,
    title: "Charge it up",
    body: "Make sure your phone is charged, or keep the charger connected.",
  },
  {
    id: "dnd",
    icon: BellOff,
    title: "Go on Do Not Disturb",
    body: "Put your phone on Silent or Do Not Disturb so calls and notifications don't interrupt the interview.",
  },
];

// Kills the ~300ms mobile tap delay + default tap-highlight flash; buttons use their own active: state.
export const TOUCH_FEEDBACK_STYLE = { touchAction: "manipulation", WebkitTapHighlightColor: "transparent" };

// Session status values returned by the /secondary-camera/sessions/:token API.
export const SESSION_STATUS = {
  PENDING: "pending",
  PAIRED: "paired",
  CLOSED: "closed",
};

// One session per (interview, round); the host passes the round when creating a QR.
export const ROUNDS = {
  CODING: "coding",
  INTERVIEW: "interview",
};

export const FACING_MODE = {
  ENVIRONMENT: "environment",
  USER: "user",
};

// Also used as the capture-canvas scale target, so an uploaded frame never
// exceeds what the camera was asked to provide.
export const CAPTURE_WIDTH = 1280;
export const CAPTURE_HEIGHT = 720;
export const CAPTURE_JPEG_QUALITY = 0.7;
export const VIDEO_READY_TIMEOUT_MS = 3000;
export const PAIRED_STORAGE_KEY_PREFIX = "sc_paired_";

// Self-heal cadence while uploads are failing (must stay above the 30s server floor).
export const UPLOAD_FAILURES_BEFORE_RECOVERY = 2;
export const UPLOAD_RECOVERY_INTERVAL_MS = 60000;
// Retry after a skipped portrait frame. Can't trip the 30s server floor: any
// upload after a skip is still ≥60s past the last accepted frame.
export const PORTRAIT_RETRY_INTERVAL_MS = 10000;

export const QR_CODE_OPTIONS = {
  width: 256,
  margin: 2,
  color: { dark: "#000000", light: "#FFFFFF" },
};
